module.exports = __webpack_public_path__ + "img/product_scan.5f9b7bb7.png";